var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 4,
    viewBox: "0 0 21 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5415 3.23796H1.45817C1.1156 3.23796 0.787059 3.09748 0.544825 2.84743C0.30259 2.59738 0.166504 2.25824 0.166504 1.90462C0.166504 1.551 0.30259 1.21186 0.544825 0.961814C0.787059 0.711765 1.1156 0.571289 1.45817 0.571289H19.5415C19.8841 0.571289 20.2126 0.711765 20.4549 0.961814C20.6971 1.21186 20.8332 1.551 20.8332 1.90462C20.8332 2.25824 20.6971 2.59738 20.4549 2.84743C20.2126 3.09748 19.8841 3.23796 19.5415 3.23796Z",
    fill: "#333300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.9c5a7b2ac584763f6bf4ab7652f68b58.svg";
export { ForwardRef as ReactComponent };